import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Products } from "@/components/Products";
import { Sculpture } from "@/components/Sculpture";
import { Realisations } from "@/components/Realisations";
import { Configurator } from "@/components/Configurator";
import { Blog } from "@/components/Blog";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";
import { AudioPlayer } from "@/components/AudioPlayer";
import { useLenis } from "@/hooks/useLenis";

export default function Home() {
  useLenis();
  return (
    <main data-testid="home-page">
      <Navbar />
      <Hero />
      <Marquee />
      <Manifesto />
      <Products />
      <Sculpture />
      <Realisations />
      <Configurator />
      <Blog />
      <Contact />
      <Footer />
      <AudioPlayer />
    </main>
  );
}
